import { render, staticRenderFns } from "./RecyclableBoxToRepair.vue?vue&type=template&id=45d4c29a&scoped=true&"
import script from "./RecyclableBoxToRepair.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxToRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4c29a",
  null
  
)

export default component.exports